export default __webpack_public_path__ + "static/momocenter-4ca15c03ea4a85f38c477a915974f046.png";